


export default class ChartComponentExample
{
  constructor(element) {

    // Elements
    this.el = element
    this.menuDropdown = d3.select("#menu select");

    // Var
    this.chartConfig = {}

    // Function bindings
    this.setupDropdownMenu = this.setupDropdownMenu.bind(this);
    this.setupBarChartConfig = this.setupBarChartConfig.bind(this);
    this.createBarChart2 = this.createBarChart2.bind(this);
    this.drawBars = this.drawBars.bind(this);
    this.init();
  }

  init()
  {    
    if(d3)
    {      
       //this.createBarChart();   

      this.loadData(); 
    }   
  } 

  /* createBarChart()
  {
    var margin = {top: 20, right: 40, bottom: 10, left: 40},
    width = 960,
    height = 250 - margin.top - margin.bottom;

    var format = d3.format(".1%"),
        states,
        age;

    var x = d3.scale.linear()
        .range([0, width]);

    var y = d3.scale.ordinal()
        .rangeRoundBands([0, height], .1);

    var xAxis = d3.svg.axis()
        .scale(x)
        .orient("top")
        .tickSize(-height - margin.bottom)
        .tickFormat(format);

    var svg = d3.select("#chart").append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("margin-left", -margin.left + "px")
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    svg.append("g")
        .attr("class", "x axis");

    svg.append("g")
        .attr("class", "y axis")
      .append("line")
        .attr("class", "domain")
        .attr("y2", height);

    var menu = d3.select("#menu select")
        .on("change", change);

    d3.csv("/assets/data/states-age.csv", (data) => {

      states = data;



      console.log("states",states)

      var ages = d3.keys(states[0]).filter((key) => {
        return key != "State" && key != "Total";
      });

      states.forEach((state) => {
        ages.forEach((age) => {
          state[age] = state[age] / state.Total;
        });
      });

      menu.selectAll("option")
          .data(ages)
        .enter().append("option")
          .text((d) => { return d; });

      menu.property("value", "18 to 24 Years");

      redraw();
    });

    var altKey;

    d3.select(window)
        .on("keydown", () =>  { altKey = d3.event.altKey; })
        .on("keyup", () => { altKey = false; });

    function change() {
   

      d3.transition()
          .duration(altKey ? 7500 : 750)
          .each(redraw);
    }

    function redraw() {
      var age1 = menu.property("value"),
          top = states.sort((a, b) => { return b[age1] - a[age1]; }).slice(0, 10);

      y.domain(top.map((d) => { return d.State; }));

      var bar = svg.selectAll(".bar")
          .data(top, (d) => { return d.State; });

      var barEnter = bar.enter().insert("g", ".axis")
          .attr("class", "bar")
          .attr("transform", (d) => { return "translate(0," + (y(d.State) + height) + ")"; })
          .style("fill-opacity", 0);

      barEnter.append("rect")
          .attr("width", age && function(d) { return x(d[age]); })
          .attr("height", y.rangeBand());

      barEnter.append("text")
          .attr("class", "label")
          .attr("x", -3)
          .attr("y", y.rangeBand() / 2)
          .attr("dy", ".35em")
          .attr("text-anchor", "end")
          .text((d) => { return d.State; });

      barEnter.append("text")
          .attr("class", "value")
          .attr("x", age && function(d) { return x(d[age]) - 3; })
          .attr("y", y.rangeBand() / 2)
          .attr("dy", ".35em")
          .attr("text-anchor", "end");

      x.domain([0, top[0][age = age1]]);

      var barUpdate = d3.transition(bar)
          .attr("transform", (d) => { return "translate(0," + (d.y0 = y(d.State)) + ")"; })
          .style("fill-opacity", 1);

      barUpdate.select("rect")
          .attr("width", (d) => { return x(d[age]); });

      barUpdate.select(".value")
          .attr("x", (d) => { return x(d[age]) - 3; })
          .text((d) => { return format(d[age]); });

      var barExit = d3.transition(bar.exit())
          .attr("transform", (d) => { return "translate(0," + (d.y0 + height) + ")"; })
          .style("fill-opacity", 0)
          .remove();

      barExit.select("rect")
          .attr("width", (d) => { return x(d[age]); });

      barExit.select(".value")
          .attr("x", (d) => { return x(d[age]) - 3; })
          .text((d) => { return format(d[age]); });

      d3.transition(svg).select(".x.axis")
          .call(xAxis);
    } 
  } */


  setupBarChartConfig(data)
  {
    // define styling of chart   
    this.chartConfig = Object.assign(this.chartConfig, 
      { 
        margin : {top: 20, right: 40, bottom: 10, left: 40 },
        barHeight : 20 
    });  

      
    this.chartConfig = Object.assign(this.chartConfig, 
      {
      width: 960,
      height: (this.chartConfig.barHeight * data.length)  - this.chartConfig.margin.top - this.chartConfig.margin.bottom,
      dataset : data,
      format: d3.format("0.1"),
      salary: null,
      x: null,
      y: null,
      xAxis: null
    });
  }


  setupDropdownMenu()
  {
    this.menuDropdown.on("change", () =>  {
        d3.transition().duration(this.chartConfig.altKey ? 7500 : 750).each(this.drawBars);
      }
    ); 

    // Create options in menu
    var dataNames = d3.keys(this.chartConfig.dataset[0]).filter((key) => {
      return key != "Persongrupper";
    });

    this.menuDropdown.selectAll("option")
      .data(dataNames)
      .enter().append("option")
      .text((d) => { return d; });

    // Select the first option
    this.menuDropdown.property("value", dataNames[0]);   
  }

  loadData()
  {
    // Read data
    d3.csv("/assets/data/1508_gnslon_persgrupper_cleaned.csv", (data) => 
    {
      if(data)
      {
        console.log("data", data)

        this.setupBarChartConfig(data);
  
        this.setupDropdownMenu();
  
        this.createBarChart2()
  
        this.drawBars(); 

        //this.drawHTMLBars();
      } 
    }); 
  }


  createBarChart2()
  {     
    var {
      width,
      height,   
      format,
      margin,
    } = this.chartConfig;


    // setup x axis and y axis scaling and format of values
    this.chartConfig.x = d3.scale.linear().range([0, width]),
    this.chartConfig.y = d3.scale.ordinal().rangeRoundBands([0, height], .1)      

    this.chartConfig.xAxis = d3.svg.axis()
        .scale(this.chartConfig.x)
        .orient("top")
        .tickSize(-height - margin.bottom)
        .tickFormat(format);
  

    this.chartConfig.svg = d3.select("#chart").append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("margin-left", -margin.left + "px")
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    this.chartConfig.svg.append("g").attr("class", "x axis");
    this.chartConfig.svg.append("g").attr("class", "y axis").append("line").attr("class", "domain").attr("y2", height);

  }

  drawHTMLBars()
  {

  }

  drawBars()
  {
    var {
      height,
      format,
      dataset,
      salary,
      y,
      x,
      svg,
      xAxis
    } = this.chartConfig;


    var selectedValue = this.menuDropdown.property("value");

    var top = this.chartConfig.dataset.sort((a, b) => { return b[selectedValue] - a[selectedValue]; });

    y.domain(top.map((d) => {  return d.Persongrupper;    }));

    var bar = svg.selectAll(".bar").data(top, (d) => { return d.Persongrupper; }); 

    console.log("bar", bar)

    var barEnter = bar.enter().insert("g", ".axis")
        .attr("class", "bar")
        .attr("transform", (d) => {           
          var yTranslate = (y(d.Persongrupper) + height); 
          return `translate(0,${yTranslate})`; 
        
        })
        .style("fill-opacity", 0);




    barEnter.append("rect")
        .attr("width", salary && function(d) { return x(d[salary]); })
        .attr("height", y.rangeBand());

    barEnter.append("text")
        .attr("class", "label")
        .attr("x", 2)
        .attr("y", 0)
        .attr("dy", "0")
        .text((d) => { return d.Persongrupper; });

    barEnter.append("text")
        .attr("class", "value")
        .attr("x", salary && function(d) { return x(d[salary]) - 3; })
        .attr("y", y.rangeBand() / 2)
        .attr("dy", ".35em")
        .attr("text-anchor", "end");

    x.domain([0, top[0][salary = selectedValue]]);

    var barUpdate = d3.transition(bar)
        .attr("transform", (d) => { 

          //var test = (d.y0 = y(d.Persongrupper)) 
          d.y0 =  y(d.Persongrupper + 30);
          console.log("test", d)
          return `translate(0,${d.y0})`; 
        })
        .style("fill-opacity", 1);

    barUpdate.select("rect")
        .attr("width", (d) => { return x(d[salary]); });

    barUpdate.select(".value")
        .attr("x", (d) => { return x(d[salary]) - 3; })
        .text((d) => { return format(d[salary]); });
    
    var barExit = d3.transition(bar.exit())
        .attr("transform", (d) => { 
          console.log("bar exit", d.y0);
          return "translate(0," + (d.y0 + height + 20) + ")"; })
        .style("fill-opacity", 0)
        .remove();

    barExit.select("rect")
        .attr("width", (d) => { return x(d[salary]); });

    barExit.select(".value")
        .attr("x", (d) => { return x(d[salary]) - 3; })
        .text((d) => { return format(d[salary]); });

    d3.transition(svg).select(".x.axis").call(xAxis);
  }


}
